import { EventEmitter } from 'events';
import dispatcher from '../dispatchers/dispatcher';

class TotemStore extends EventEmitter {
    constructor() {
        super();
        this.articles = [];
        this.categories = [];
        this.brands = [];
    }

    getArticles() {
        return this.articles;
    }
    getBrands() {
        return this.brands;
    }
    getCategories() {
        return this.categories;
    }

    handleActions(action) {
        switch (action.type) {
            case 'GET_ARTICLES': {
                action.articles.forEach((article) => {
                    this.articles.push(article);
                });
                this.emit('ARTICLES_RECEIVED');
                break;
            }
            case 'NO_NETWORK_CONNECTION': {
                this.emit('NO_NETWORK_CONNECTION');
                break;
            }
            case 'ARTICLE_DELETED': {
                let delIndex = -1
                this.articles.forEach((elem, index) => {
                    if (elem.id === action.itemId) {
                        delIndex = index;
                    }
                });
                if (delIndex > -1) {
                    this.articles.splice((delIndex), 1);
                    this.emit('ARTICLES_RECEIVED');
                }
                break;
            }
            case 'ARTICLE_CREATED': {
                this.articles.push(action.item);
                this.emit('ARTICLES_RECEIVED');
                break;
            }
            case 'GET_CATEGORIES': {
                this.categories = [];
                action.categories.forEach((category) => {
                    this.categories.push(category);
                });
                this.emit('CATEGORIES_RECEIVED');
                break;
            }
            case 'GET_BRANDS': {
                this.brands = [];
                action.brands.forEach((brand) => {
                    this.brands.push(brand);
                });
                this.emit('BRANDS_RECEIVED');
                break;
            }
        }
    }
}

const totemStore = new TotemStore;
dispatcher.register(totemStore.handleActions.bind(totemStore));

export default totemStore;


// WEBPACK FOOTER //
// ./src/stores/TotemStore.js